import { render, staticRenderFns } from "./ProductBuySimple.vue?vue&type=template&id=c77bbc3e&"
import script from "./ProductBuySimple.vue?vue&type=script&lang=js&"
export * from "./ProductBuySimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports